import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute.jsx";
import PasswordContextProvider from "../contexts/PasswordContext";

const counteringRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/counter-receipt/creating",
      element: ProtectedRoute,
      permission_id: 21,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/countering/DocumentCounterReceiptCreating")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/counter-receipt/new-counter-receipt",
      element: ProtectedRoute,
      permission_id: 21,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/countering/NewCounterReceipt")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/counter-receipt/update-counter-receipt/:id",
      element: ProtectedRoute,
      permission_id: 21,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/countering/UpdateCounterReceipt")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/counter-receipt/monitoring",
      element: ProtectedRoute,
      permission_id: 22,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/countering/DocumentCounterReceiptMonitoring")),
      wrapper: PasswordContextProvider,
    },
  },
];

export default counteringRouteConfig;
